const url = process.env.NODE_ENV === 'development' ? "http://localhost:8000" : "https://api.ancorei.laonlabs.com";

export const Constants = {
    url,
    baseUrl: url + "/api/admin",
    whatsappLink: "https://api.whatsapp.com/send?phone=554298190145&text=Ol%C3%A1!%20",
};
